var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHangup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40005 16.4L1.10005 14.15C0.900049 13.95 0.800049 13.7167 0.800049 13.45C0.800049 13.1833 0.900049 12.95 1.10005 12.75C2.56672 11.1667 4.25838 9.97917 6.17505 9.1875C8.09172 8.39583 10.0334 8 12 8C13.9667 8 15.9042 8.39583 17.8125 9.1875C19.7209 9.97917 21.4167 11.1667 22.9 12.75C23.1 12.95 23.2 13.1833 23.2 13.45C23.2 13.7167 23.1 13.95 22.9 14.15L20.6 16.4C20.4167 16.5833 20.2042 16.6833 19.9625 16.7C19.7209 16.7167 19.5 16.65 19.3 16.5L16.4 14.3C16.2667 14.2 16.1667 14.0833 16.1 13.95C16.0334 13.8167 16 13.6667 16 13.5V10.65C15.3667 10.45 14.7167 10.2917 14.05 10.175C13.3834 10.0583 12.7 10 12 10C11.3 10 10.6167 10.0583 9.95005 10.175C9.28338 10.2917 8.63338 10.45 8.00005 10.65V13.5C8.00005 13.6667 7.96672 13.8167 7.90005 13.95C7.83338 14.0833 7.73338 14.2 7.60005 14.3L4.70005 16.5C4.50005 16.65 4.27922 16.7167 4.03755 16.7C3.79588 16.6833 3.58338 16.5833 3.40005 16.4ZM6.00005 11.45C5.51672 11.7 5.05005 11.9875 4.60005 12.3125C4.15005 12.6375 3.68338 13 3.20005 13.4L4.20005 14.4L6.00005 13V11.45ZM18 11.5V13L19.8 14.4L20.8 13.45C20.3167 13.0167 19.85 12.6417 19.4 12.325C18.95 12.0083 18.4834 11.7333 18 11.5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangup);
export default __webpack_public_path__ + "static/media/hangup.949228f8b6bb30ecb1a4a030d71fc73c.svg";
export { ForwardRef as ReactComponent };